import type {
  IssueTypeField,
  UIFieldDefinition
} from '../prepareSendIssueFields';
import {
  IssueFieldSource,
  type MappingDefinition
} from './MappingSchemaModels';
import {
  JiraFieldMappersKeys,
  type UIFieldInputType,
  type UiFieldValidationError,
  type JiraFieldMapper
} from './MapperInterface';

export const maxShortTextLength = 255;

export class ShortTextMapper implements JiraFieldMapper {
  id = JiraFieldMappersKeys.ShortText;
  isEnum = false;

  canMapThisField(jiraSchema: IssueTypeField): boolean {
    const { type, custom } = jiraSchema.schema;
    const isCustomType = !!custom;
    const isString = type === 'string';

    return isCustomType
      ? isString &&
          custom ===
            'com.atlassian.jira.plugin.system.customfieldtypes:textfield'
      : isString;
  }

  getDisplayValue(
    fieldSchema: IssueTypeField,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    axeIssue: any,
    fieldMapping?: MappingDefinition
  ): { value?: string; uiFieldType: UIFieldInputType } {
    // If we have a mapping, use it and ignore all else
    if (fieldMapping && fieldMapping.sourceType === IssueFieldSource.Axe) {
      return {
        value: axeIssue[fieldMapping.source] as string,
        uiFieldType: 'text'
      };
      // Of if there is a default value, use it
    } else if (fieldSchema.hasDefaultValue && fieldSchema.defaultValue) {
      return {
        value: fieldSchema.defaultValue as string,
        uiFieldType: 'text'
      };
    }

    return {
      uiFieldType: 'text'
    };
  }

  convertDisplayToIntegrationValue(uiFieldDefinition: UIFieldDefinition): {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    integrationValue: any;
    error?: UiFieldValidationError;
  } {
    // Check for a case when there is no value provided
    if (!uiFieldDefinition.value || uiFieldDefinition.value === '') {
      if (uiFieldDefinition.rawSchema.required) {
        return {
          integrationValue: undefined,
          error: {
            isMissingRequired: true,
            isInvalidValue: false,
            isLengthTooLong: false
          }
        };
      } else {
        return {
          integrationValue: undefined
        };
      }
    }

    // If value is provided, check that it's valid
    if (uiFieldDefinition.value.length > maxShortTextLength) {
      return {
        integrationValue: undefined,
        error: {
          isMissingRequired: false,
          isInvalidValue: false,
          isLengthTooLong: true
        }
      };
    }

    return {
      integrationValue: uiFieldDefinition.value.replaceAll('\n', ' ')
    };
  }
}
